import { Component, Inject } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { SharedModule } from "../shared.module";
import { ToastrService } from "../toastr.service";
import type { DomainVariablesDialogData } from "./domain-variables-dialog.interface";

@Component({
  selector: "app-domain-variables-dialog",
  templateUrl: "./domain-variables-dialog.component.html",
  styleUrls: ["./domain-variables-dialog.component.scss"],
  standalone: true,
  imports: [SharedModule, ReactiveFormsModule],
})
export class DomainVariablesDialogComponent {
  readonly searchControl = new FormControl("", { nonNullable: true });
  readonly tokens: string[];

  constructor(
    private readonly dialogRef: MatDialogRef<DomainVariablesDialogComponent>,
    private readonly toastr: ToastrService,
    private readonly translate: TranslateService,
    @Inject(MAT_DIALOG_DATA)
    data: DomainVariablesDialogData,
  ) {
    const placeholderKeys = data.placeholderKeys ?? {};
    const unique = new Set<string>();
    for (const raw of data.variables ?? []) {
      const name = raw.trim();
      if (!name) {
        continue;
      }
      unique.add(`\${${placeholderKeys[name] ?? name}}`);
    }
    this.tokens = [...unique].sort((a, b) => a.localeCompare(b));
  }

  get filteredTokens(): string[] {
    const term = this.searchControl.value.trim().toLowerCase();
    if (!term) {
      return this.tokens;
    }
    return this.tokens.filter((token) => token.toLowerCase().includes(term));
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onCopy(token: string): void {
    void navigator.clipboard.writeText(token).then(
      () => {
        this.toastr.info(
          this.translate.instant("domainVariablesDialog.copied") as string,
        );
      },
      () => {
        this.toastr.error(
          this.translate.instant("domainVariablesDialog.copyFailed") as string,
        );
      },
    );
  }
}
